(function(){
  'use strict';

  function initProductGallerySwipe(scope){
    scope=scope||document;
    var root=scope.querySelector?scope.querySelector('[data-fcv5-root]'):null;
    if(!root&&scope.matches&&scope.matches('[data-fcv5-root]'))root=scope;
    if(!root||root.getAttribute('data-fc-gallery-swipe-ready')==='true')return;

    var main=root.querySelector('[data-fcv5-main]');
    var thumbs=Array.prototype.slice.call(root.querySelectorAll('.fcv5-thumb[data-src]'));
    if(!main||thumbs.length<2)return;

    root.setAttribute('data-fc-gallery-swipe-ready','true');

    var mainSurface=main.closest?main.closest('.fcv5-main'):main.parentNode;
    var modal=root.querySelector('[data-fcv5-modal]');
    var modalImage=modal?modal.querySelector('img'):null;
    var activeIndex=0;
    var suppressMainClickUntil=0;

    for(var i=0;i<thumbs.length;i++){
      if(thumbs[i].classList.contains('active')){
        activeIndex=i;
        break;
      }
    }

    if(mainSurface)mainSurface.style.touchAction='pan-y';
    main.style.touchAction='pan-y';
    main.setAttribute('draggable','false');
    if(modalImage){
      modalImage.style.touchAction='pan-y';
      modalImage.setAttribute('draggable','false');
    }

    thumbs.forEach(function(thumb,index){
      thumb.addEventListener('click',function(){
        activeIndex=index;
        if(modal&&modal.classList.contains('open')&&modalImage){
          window.requestAnimationFrame(function(){
            modalImage.src=main.currentSrc||main.src;
          });
        }
      });
    });

    function showIndex(index){
      index=Math.max(0,Math.min(thumbs.length-1,index));
      if(index===activeIndex)return;
      activeIndex=index;
      thumbs[index].click();
      if(modal&&modal.classList.contains('open')&&modalImage){
        window.requestAnimationFrame(function(){
          modalImage.src=main.currentSrc||main.src;
        });
      }
    }

    function completeSwipe(endX,endY,startX,startY,suppressMainTap){
      var dx=endX-startX;
      var dy=endY-startY;
      var horizontal=Math.abs(dx)>=40&&Math.abs(dx)>Math.abs(dy)*1.2;
      if(!horizontal)return;
      if(suppressMainTap)suppressMainClickUntil=Date.now()+350;
      showIndex(activeIndex+(dx<0?1:-1));
    }

    function bindSwipe(surface,suppressMainTap){
      if(!surface)return;

      if(window.PointerEvent){
        var pointerId=null,startX=0,startY=0,tracking=false;
        surface.addEventListener('pointerdown',function(event){
          if(event.pointerType==='mouse')return;
          pointerId=event.pointerId;
          startX=event.clientX;
          startY=event.clientY;
          tracking=true;
        });
        surface.addEventListener('pointerup',function(event){
          if(!tracking||event.pointerId!==pointerId)return;
          tracking=false;
          completeSwipe(event.clientX,event.clientY,startX,startY,suppressMainTap);
        });
        surface.addEventListener('pointercancel',function(event){
          if(event.pointerId===pointerId)tracking=false;
        });
      }else{
        var touchStartX=0,touchStartY=0,touchTracking=false;
        surface.addEventListener('touchstart',function(event){
          if(event.touches.length!==1)return;
          touchStartX=event.touches[0].clientX;
          touchStartY=event.touches[0].clientY;
          touchTracking=true;
        },{passive:true});
        surface.addEventListener('touchend',function(event){
          if(!touchTracking||!event.changedTouches.length)return;
          touchTracking=false;
          completeSwipe(event.changedTouches[0].clientX,event.changedTouches[0].clientY,touchStartX,touchStartY,suppressMainTap);
        },{passive:true});
        surface.addEventListener('touchcancel',function(){touchTracking=false;},{passive:true});
      }
    }

    bindSwipe(mainSurface,true);
    bindSwipe(modalImage,false);

    main.addEventListener('click',function(event){
      if(Date.now()>=suppressMainClickUntil)return;
      suppressMainClickUntil=0;
      event.preventDefault();
      event.stopImmediatePropagation();
    },true);
  }

  function init(){initProductGallerySwipe(document);}

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();

  document.addEventListener('shopify:section:load',function(event){
    initProductGallerySwipe(event.target||document);
  });
})();
